import InvoiceLetterhead from './InvoiceLetterhead';
import InvoiceMetaGridReadonly from './InvoiceMetaGridReadonly';
import InvoiceItemsTableReadonly from './InvoiceItemsTableReadonly';
import InvoiceTotalsReadonly from './InvoiceTotalsReadonly';
import BankDetailsSection from './BankDetailsSection';
import DriveSyncInfo from './DriveSyncInfo';
import SubInvoicesPanel from './SubInvoicesPanel';

export default function InvoiceView({ invoice, saleDocumentTitle, onEdit, onBack, onDownload, onDelete, onDeleteSubInvoice, onDeleteAllSubInvoices }) {
  return (
    <div className="invoice-sheet">
      <InvoiceLetterhead type={invoice.type} saleDocumentTitle={saleDocumentTitle} />
      <InvoiceMetaGridReadonly invoice={invoice} />
      <InvoiceItemsTableReadonly items={invoice.items} />
      <InvoiceTotalsReadonly
        subtotal={invoice.subtotal}
        vatAmount={invoice.vatAmount}
        delivery={invoice.delivery}
        grandTotal={invoice.grandTotal}
      />

      {invoice.type === 'sale' && <BankDetailsSection />}

      {/* Sub-invoices: auto-added items split into £100 batches */}
      <SubInvoicesPanel
        subInvoices={invoice.subInvoices}
        invoiceId={invoice._id}
        onDeleteSubInvoice={onDeleteSubInvoice}
        onDeleteAllSubInvoices={onDeleteAllSubInvoices}
      />

      <DriveSyncInfo invoice={invoice} />

      <div className="editor-actions no-print">
        <button className="btn btn-ghost" onClick={onBack}>← Back</button>
        <button className="btn btn-outline" onClick={() => window.print()}>🖨 Print</button>
        <button className="btn btn-outline" onClick={onDownload}>📥 XLSX</button>
        <button
          className="btn btn-outline"
          style={{ borderColor: 'var(--danger, #9b2335)', color: 'var(--danger, #9b2335)' }}
          onClick={() => onDelete && onDelete(invoice._id)}
        >
          🗑 Delete
        </button>
        <button className="btn btn-primary" onClick={onEdit}>✏ Edit</button>
      </div>
    </div>
  );
}

